
// Imagens próprias para grupos que antes compartilhavam a mesma foto (fotos trocadas)
import ursoImg from "@/assets/bicho-23-urso.png";
import veadoImg from "@/assets/bicho-24-veado.png";
import vacaImg from "@/assets/bicho-25-vaca.png";

// Mapeamento dos grupos para os animais do jogo do bicho

export const animalMapping: Record<string, { name: string; image: string; dezenas: number[] }> = {
  "01": { 
    name: "Avestruz", 
    image: "/lovable-uploads/4994df13-df60-40c7-8344-b33e38cee575.png",
    dezenas: [1, 2, 3, 4]
  },
  "02": { 
    name: "Águia", 
    image: "/lovable-uploads/4abd8503-fb00-4def-925a-ce5222dc64cb.png",
    dezenas: [5, 6, 7, 8]
  },
  "03": { 
    name: "Burro", 
    image: "/lovable-uploads/d0503b3f-03d6-4e36-8439-13b9b271fdb0.png",
    dezenas: [9, 10, 11, 12]
  },
  "04": { 
    name: "Borboleta", 
    image: "/lovable-uploads/82fdc59e-810d-4c25-8fb6-cd9aa1feda58.png",
    dezenas: [13, 14, 15, 16]
  },
  "05": { 
    name: "Cachorro", 
    image: "/lovable-uploads/9c0f0eef-a059-4ab9-bd1f-e925415453c0.png",
    dezenas: [17, 18, 19, 20]
  },
  "06": { 
    name: "Cabra", 
    image: "/lovable-uploads/f253ee6e-825b-4ff8-8aab-89f49496cda4.png",
    dezenas: [21, 22, 23, 24]
  },
  "07": { 
    name: "Carneiro", 
    image: "/lovable-uploads/73a70ce9-cf75-48e2-a2d6-e7a8568dc0fd.png",
    dezenas: [25, 26, 27, 28]
  },
  "08": { 
    name: "Camelo", 
    image: "/lovable-uploads/54ef2a22-056d-404e-9890-8a2715011fbd.png",
    dezenas: [29, 30, 31, 32]
  },
  "09": { 
    name: "Cobra", 
    image: "/lovable-uploads/7fca9c61-016a-4e2e-ac0b-906c219a6543.png",
    dezenas: [33, 34, 35, 36]
  },
  "10": { 
    name: "Coelho", 
    image: "/lovable-uploads/b4a93708-d4c0-4185-adcd-28218adfabf5.png",
    dezenas: [37, 38, 39, 40]
  },
  "11": { 
    name: "Cavalo", 
    image: "/lovable-uploads/d6419fd9-d14c-4508-ad0e-01d181cf35ec.png",
    dezenas: [41, 42, 43, 44]
  },
  "12": { 
    name: "Elefante", 
    image: "/lovable-uploads/e5785f0f-3e98-40ea-94dc-7136d4170290.png",
    dezenas: [45, 46, 47, 48]
  },
  "13": { 
    name: "Galo", 
    image: "/lovable-uploads/17eb41e8-0412-41a6-a129-eb8e660481e9.png",
    dezenas: [49, 50, 51, 52]
  },
  "14": { 
    name: "Gato", 
    image: "/lovable-uploads/e6b10054-335d-46d0-b0b6-051075c5e70a.png",
    dezenas: [53, 54, 55, 56]
  },
  "15": { 
    name: "Jacaré", 
    image: "/lovable-uploads/074e5b117-27b0-40d2-8d1f-9e642d97fdd8.png",
    dezenas: [57, 58, 59, 60]
  },
  "16": { 
    name: "Leão", 
    image: "/lovable-uploads/d3190d13-0052-43aa-bcbc-e6f2415ec967.png",
    dezenas: [61, 62, 63, 64]
  },
  "17": { 
    name: "Macaco", 
    image: "/lovable-uploads/b08e1f1a-87be-42f6-9090-091809a899fb.png",
    dezenas: [65, 66, 67, 68]
  },
  "18": { 
    name: "Porco", 
    image: "/lovable-uploads/cb9a0598-cfab-4942-9e5b-0bc7818636d7.png",
    dezenas: [69, 70, 71, 72]
  },
  "19": { 
    name: "Pavão", 
    image: "/lovable-uploads/3a6669de-1f29-410c-b753-c7231c27f6a0.png",
    dezenas: [73, 74, 75, 76]
  },
  "20": { 
    name: "Peru", 
    image: "/lovable-uploads/baa52fd2-3063-466d-8043-fd9d3a0e7b35.png",
    dezenas: [77, 78, 79, 80]
  },
  "21": { 
    name: "Touro", 
    image: "/lovable-uploads/076a267d-c625-45d6-b72f-89815deffca7.png",
    dezenas: [81, 82, 83, 84]
  },
  "22": { 
    name: "Tigre", 
    image: "/lovable-uploads/5be4dc4c-dfb5-43ab-9525-f1ab49b796ab.png",
    dezenas: [85, 86, 87, 88]
  },
  "23": { 
    name: "Urso", 
    image: ursoImg,
    dezenas: [89, 90, 91, 92]
  },
  "24": { 
    name: "Veado", 
    image: veadoImg,
    dezenas: [93, 94, 95, 96]
  },
  "25": { 
    name: "Vaca", 
    image: vacaImg,
    dezenas: [97, 98, 99, 0]
  },

};

// Função para determinar o grupo baseado no número
export const getGroupFromNumber = (number: string): string | null => {
  // Se for vazio, retornar null
  if (!number || number.length === 0) return null;
  
  // Para milhar ou centena, pegamos os dois últimos dígitos
  let lastTwoDigits: number;
  
  if (number.length >= 2) {
    lastTwoDigits = parseInt(number.slice(-2));
  } else {
    lastTwoDigits = parseInt(number);
  }
  
  // Caso especial: 00 pertence ao grupo 25 (Vaca)
  if (lastTwoDigits === 0) return "25";
  
  // Procurar grupo correspondente à dezena
  for (const [group, info] of Object.entries(animalMapping)) {
    if (info.dezenas.includes(lastTwoDigits)) {
      return group;
    }
  }
  
  return null;
};

// Função para obter informações do animal com base na predição
export const getAnimalInfo = (prediction: string, predictionType: string): { name: string; image: string; firstLetter: string } => {
  let animalData = { name: "Desconhecido", image: "", firstLetter: "?" };
  
  if (predictionType === "grupo") {
    // Se já for um grupo, usamos o valor diretamente
    if (animalMapping[prediction]) {
      animalData = { 
        ...animalMapping[prediction], 
        firstLetter: animalMapping[prediction].name.charAt(0)
      };
    }
  } else if (predictionType === "milhar" || predictionType === "centena") {
    // Para milhar ou centena, obtemos o grupo
    const group = getGroupFromNumber(prediction);
    if (group && animalMapping[group]) {
      animalData = { 
        ...animalMapping[group], 
        firstLetter: animalMapping[group].name.charAt(0)
      };
    }
  } else if (predictionType === "duque" || predictionType === "terno") {
    // Para duque e terno, obtemos o primeiro número (apenas para visualização)
    const firstNumber = prediction.split('-')[0];
    const group = getGroupFromNumber(firstNumber);
    if (group && animalMapping[group]) {
      animalData = { 
        ...animalMapping[group], 
        firstLetter: animalMapping[group].name.charAt(0)
      };
    }
  }
  
  return animalData;
};
